import {ApplicationRef, Component, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import {CommonConstants} from '../../util/common-constants';
import {AuthService} from '../../service/auth/auth.service';
import {ScreenService} from '../../service/screen/screen.service';
import {NavigationService} from '../../service/navigation/navigation.service';
import {valueReferenceToExpression} from '@angular/compiler-cli/src/ngtsc/annotations/src/util';
import {error} from 'protractor';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit {

  @ViewChild('sidenav') public sidenav: MatSidenav;
  expandBreadcrumb: boolean = false;
  sidenavToggled = true;

  constructor(public constants: CommonConstants,
              public authService: AuthService,
              public screenService: ScreenService,
              private navService: NavigationService,
              private snackbar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.navService.onNavigationItemClick.subscribe(e => {
      this.toggleSidenav(e).then(r => r);
    }, error => {
      this.snackbar.open(`ERROR: Konnte nicht navigieren ${error}`);
    });
  }

  public setActive(id: string) {
    document.getElementById('nav_mat_list_item_' + id).className = 'mat_list_item_active';
  }

  toggleSidenav(event?) {
    this.sidenavToggled ? this.sidenavToggled = false : this.sidenavToggled = true;
    return this.sidenav.toggle();
  }
}
